import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { createQueryKeySet } from '~/utils/query-keys';

export type RoundResultsEligibleResultsListQueryParams = Parameters<typeof SSF.api.roundResultsEligibleResultsList>[0];

export const keys = createQueryKeySet<RoundResultsEligibleResultsListQueryParams>('round-results-eligible-results');

export function useEligibleRoundResultsListQuery(params: RoundResultsEligibleResultsListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.roundResultsEligibleResultsList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
